<template>
  <div>
    <b-row class="py-2">
      <b-col cols="12" v-if="sinDispo.is">
        <v-alert :value="true" color="warning" icon="priority_high" outline>
          <p class="my-0 text-center">
            {{ sinDispo.mensaje }}
          </p>
        </v-alert>
      </b-col>
      <b-col cols="12" v-if="alternativo.is">
        <!--v-if="showAlternativo"-->
        <v-chip label color="light-blue lighten-5" text-color="light-blue darken-4">
          <v-icon left>info</v-icon>
          {{ alternativo.mensaje }}
        </v-chip>
      </b-col>
      <b-col cols="12" v-for="(c, index) in cuposRs.cupos" :key="index">
        <PanelCupo :cupo="c" :index="index" :busqueda="cuposRs.busqueda" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Loading from "@/components/utiles/Loading.vue"
const PanelCupo = () => ({
  // The component to load (should be a Promise)
  component: import("@/components/cupos/PanelCupo.vue"),
  // A component to use while the async component is loading
  loading: Loading,
  // A component to use if the load fails
  // error: ErrorComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 1,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
})
export default {
  name: "inicio",
  components: {
    PanelCupo
  },
  mounted() {},
  beforeCreate() {},
  methods: {},
  computed: {
    ...mapGetters("cupo", {
      cuposRs: "getCuposRs",
      sinDispo: "getSinDispo",
      destino: "getDestino"
    }),
    alternativo: function() {
      if (this.destino === null) {
        return { is: false }
      }
      if (!(this.destino.alternativa === null) && this.cuposRs.cupos.length > 0) {
        const mensaje = `Mostramos cupos aéreos a ${this.destino.alternativa}`
        return { is: true, mensaje }
      }
      return { is: false }
    }
  }
}
</script>
